import { Mail, Phone, ClipboardCheck, MessageSquare, CalendarPlus, FileSignature, Target, UserRound } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { initial, alsText } from '@/lib/text';
import { datumKurz, STATUS_KLASSE } from '@/components/kundenakte/akteText';

/* Kopf der Kundenakte (28.10.2026, Brief 3.1): Avatar, Name, Alter, Mitglied seit, Tarif, Bausteine als Chips, Status,
   Hauptziel, Coach — alles aus GET /api/kunden/{id}/akte. Ohne Akte (lädt noch / Fehler) steht der Lead wie bisher.
   Aktionen: Check-up starten (öffnet den Stepper zum bestätigten Check-up `akte.checkup_start`, ohne einen die Karte
   „Check-Up“), Nachricht, Termin, Angebot erstellen (manuelles Leistungsangebot in die App, `AngebotErstellen`). */
/* `gross` (Trainer-Webseite /coach, Tablet): Knöpfe mit 44 px Höhe; ohne `onTermin` fehlt der Knopf „Termin“. */
export default function AkteKopf({ lead, akte, stufeText, onCheckup, onNachricht, onTermin, onAngebot, darfAngebot = true, gross = false }) {
  const kg = gross ? 'min-h-11 px-4' : '';
  const k = akte?.kopf;
  const status = k?.status;
  const fakten = [
    k?.alter != null ? `${k.alter} Jahre` : null,
    k?.mitglied_seit ? `Mitglied seit ${datumKurz(k.mitglied_seit)}` : null,
  ].filter(Boolean);
  return (
    <div className="min-w-0 space-y-2" data-testid="akte-kopf">
      <div className="flex items-center gap-3 sm:gap-4">
        <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full bg-marke/10 flex items-center justify-center text-base sm:text-xl font-bold text-marke flex-shrink-0">
          {initial(lead.name)}
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-lg sm:text-2xl font-bold tracking-tight truncate">{alsText(lead.name)}</h1>
            {status && (
              <span className={`rounded-full border px-2 py-0.5 text-[11px] font-semibold ${STATUS_KLASSE[status.schluessel] || STATUS_KLASSE.lead}`} data-testid="akte-status">
                {status.schluessel === 'lead' ? (stufeText?.(status.stufe) || status.text) : status.text}
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 sm:gap-3 mt-0.5 sm:mt-1 flex-wrap text-sm">
            {lead.mitgliedsnummer && <span className="font-mono font-semibold text-foreground" title="Mitgliedsnummer (für Kündigung und Rückfragen)" data-testid="lead-mitgliedsnummer">Nr. {lead.mitgliedsnummer}</span>}
            {fakten.map((f) => <span key={f} className="text-muted-foreground">{f}</span>)}
            {lead.email && <span className="text-muted-foreground flex items-center gap-1"><Mail className="w-3 h-3" />{lead.email}</span>}
            {lead.phone && <span className="text-muted-foreground flex items-center gap-1"><Phone className="w-3 h-3" />{lead.phone}</span>}
          </div>
        </div>
      </div>
      {k && (k.bausteine?.length > 0 || k.hauptziel || k.coach) && (
        <div className="flex items-center gap-1.5 flex-wrap" data-testid="akte-bausteine">
          {(k.bausteine || []).map((b, i) => (
            <span key={`${b.art}-${i}`} className={`rounded-md border px-2 py-0.5 text-xs font-medium ${b.art === 'tarif' ? 'border-marke/30 bg-marke/10 text-marke' : 'border-border bg-muted/60'}`}>{b.text}</span>
          ))}
          {k.hauptziel && <span className="inline-flex items-center gap-1 text-xs text-muted-foreground ml-1"><Target className="w-3.5 h-3.5" />{k.hauptziel}</span>}
          {k.coach && <span className="inline-flex items-center gap-1 text-xs text-muted-foreground ml-1"><UserRound className="w-3.5 h-3.5" />Coach {k.coach}</span>}
        </div>
      )}
      <div className="flex items-center gap-2 flex-wrap pt-1">
        <Button size="sm" className={`gap-1 bg-marke hover:bg-marke-dunkel text-white ${kg}`} onClick={onCheckup} data-testid="akte-checkup-starten"><ClipboardCheck className="w-4 h-4" /> Check-up starten</Button>
        <Button size="sm" variant="outline" className={`gap-1 ${kg}`} onClick={onNachricht} data-testid="akte-nachricht"><MessageSquare className="w-4 h-4" /> Nachricht</Button>
        {onTermin && <Button size="sm" variant="outline" className={`gap-1 ${kg}`} onClick={onTermin} data-testid="akte-termin"><CalendarPlus className="w-4 h-4" /> Termin</Button>}
        {darfAngebot && <Button size="sm" variant="outline" className={`gap-1 ${kg}`} onClick={onAngebot} data-testid="akte-angebot"><FileSignature className="w-4 h-4" /> Angebot erstellen</Button>}
      </div>
    </div>
  );
}
